import { types } from '../../../types/types';

export const pesquisaCargosReducer = (state = {}, action = {}) => {
    
    let result = {};

    switch (action.type) {
        case types.CREDENCIAMENTO.CARGOS_PESQUISA:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }

    return result;
}